
import React from "react";



function Logosbrand (){
return(

    <section className="logos-section section-spacer">
    <div className="container">
        <h2 className="sections-title">Logos (Brands)</h2>
        <div className="row">
<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-1.png" alt="" />
    </div>
</div>

<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-2.png" alt="" />
    </div>
</div>

<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-3.png" alt="" />
    </div>
</div>

<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-1.png" alt="" />
    </div>
</div>

<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-4.png" alt="" />
    </div>
</div>

<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-5.png" alt="" />
    </div>
</div>

<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-1.png" alt="" />
    </div>
</div>

<div className="col-md-3 col-6">
    <div className="brand-logo-parent">
<img height={100} width={100} src="/assets/images/brand-logo-6.png" alt="" />
    </div>
</div>

        </div>
    </div>
</section>
);
}

export default Logosbrand;